export default __webpack_public_path__ + "static/imgExcess-cb4850b6df400fd70223b1919dc9e489.webp";